import React from 'react'
import Mainlayout from '../layouts/Mainlayout'

function News() {
    const newsStyle={
        padding: '20px',
    backgroundColor: '#f4f4f4',
    borderRadius: '8px',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    }

    const headingStyle = {
        color: '#333',
        fontSize: '2em',
      }

  return (
    <Mainlayout>
       <div className="news" style={newsStyle}>
        <h1 style={headingStyle}>News Page</h1>
        <p>Welcome to the News Page</p>
      </div>
        
    </Mainlayout>
  )
}

export default News